function registerFeaturedContent(){
  const elems = document.querySelectorAll('.featured-content');

  if (elems.length <= 0) {
    return;
  }

  elems.forEach(function (elem) {
    elem.querySelectorAll('.fc-slide').forEach(slide => {
      let button = slide.querySelector('.fc-slide-viewmore a');
      setViewMoreLink(slide)

      button.addEventListener('click', function (e) {
        const contentSummary = slide.querySelector('.fc-slide-content-summary');
        contentSummary.classList.toggle('fade-text');

      });
    });
  })

}

function setViewMoreLink(slide) {
  const height = slide.querySelector('.fc-slide-content').scrollHeight;
  const contentSummary = slide.querySelector('.fc-slide-content-summary');
  if (height < 277) {
    const showMoreLink = slide.querySelector('.fc-slide-viewmore');
    showMoreLink.style.display = 'none';
  }
  else {
    contentSummary.classList.add('fade-text');
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  registerFeaturedContent()
})
